import React from 'react';

import { Dimensions, View } from 'react-native';

// eslint-disable-next-line import/no-extraneous-dependencies
import EPGSkeletonLoadingDesktopBottom from 'assets/images/animation/epg_loading_desktop_bottom.svg';
// eslint-disable-next-line import/no-extraneous-dependencies
import EPGSkeletonLoadingDesktopTop from 'assets/images/animation/epg_loading_desktop_top.svg';

import { widthPercentageToDP } from 'utils/responsiveness';

import styles from './styles';

function EpgDesktopSkeletonLoading() {
    const aspectRatioTop = 176 / 92;
    const aspectRatioBottom = 1136 / 300;

    return (
        <View style={styles.root}>
            <EPGSkeletonLoadingDesktopTop
                viewBox="0 0 176 92"
                width={widthPercentageToDP(176)}
                height={widthPercentageToDP(176) / aspectRatioTop}
            />
            <EPGSkeletonLoadingDesktopBottom
                viewBox="0 0 1136 300"
                width={Dimensions.get('window').width - 144}
                height={Dimensions.get('screen').width / aspectRatioBottom}
            />
        </View>
    );
}

export default EpgDesktopSkeletonLoading;
